import { environment } from '../../../environments/environment';

export function getApiBaseUrl(): string {
  return environment.apiUrl.endsWith('/') ? environment.apiUrl : `${environment.apiUrl}/`;
}
